export const reviews = [
  {
    text: 'Najlepszy kebab w okolicy! Mięso dobrze doprawione i soczyste, warzywa świeże, a sos idealnie dopełnia całość.',
    author: 'Aleksandra Poniewierka',
  },
  {
    text: 'Świetne miejsce na szybki i naprawdę smaczny posiełk. Jedzenie zawsze świeże, porcje solidne i sycące.',
    author: 'Kamil Urtnowski',
  },
  {
    text: 'NIEBO W GĘBIE ❤️ Chłopaki uznali jednogłośnie, że to najlepszy kebab jaki jedli.',
    author: 'Joaśka',
  },
  {
    text: 'Bardzo dobry kebab. Miła obsługa. Nietypowa pita ale wszystko razem bardzo dobrze się komponuje.',
    author: 'Jan Paradyż',
  },
  {
    text: 'Klimacik diner baru rodem z USA oferta kurczaki i kebaby wszystko w bardzo przystępnej cenie.',
    author: 'Kuba Dundelski',
  },
  {
    text: 'Jedzenie obsługa klimat wszystko na plus. Lokalizacja też bardzo dobra ponieważ znajduje się przy samym rynku.',
    author: 'Lola Bunny',
  },
];
